import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/member";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { t, L } = useLang();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data.user);
      toast.success(L("欢迎回来！", "Welcome back!"));
      navigate(data.user.role === "admin" ? "/admin" : data.user.role === "vendor" ? "/vendor" : "/member");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white fk-border-thick rounded-2xl p-8 fk-shadow">
        <h1 className="font-display text-4xl">{t("login")}</h1>
        <p className="text-black/60 text-sm mt-1">放空生活集 · Fangkong</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Input required type="email" placeholder={t("email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" className="fk-border rounded-lg" />
          <Input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" className="fk-border rounded-lg" />
          <button disabled={loading} data-testid="login-submit" className="w-full fk-border rounded-full px-6 py-3 font-semibold bg-[#FFD93D] fk-lift disabled:opacity-50">
            {loading ? "…" : t("login")}
          </button>
        </form>
        <div className="my-4 flex items-center gap-3 text-black/40 text-xs font-mono-fk"><div className="flex-1 h-px bg-black/15" />OR<div className="flex-1 h-px bg-black/15" /></div>
        <button onClick={googleLogin} data-testid="login-google" className="w-full fk-border rounded-full px-6 py-3 font-semibold bg-white fk-lift flex items-center justify-center gap-2">
          <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> {L("使用 Google 登录", "Continue with Google")}
        </button>
        <p className="text-sm text-center mt-5 text-black/60">
          {L("还没有账号？", "No account?")} <Link to="/register" className="underline font-semibold">{t("register")}</Link>
          {" · "}
          <Link to="/vendor-register" className="underline font-semibold">{t("join_market")}</Link>
        </p>
      </div>
    </div>
  );
}
